/* React */
import React from "react";

/* Stylesheet */
import styles from "./LabelContainer.module.scss";

/* Interfaces */
interface LabelContainerProps {
  label: string;
  description?: string;
}

const LabelContainer: React.FC<LabelContainerProps> = ({
  label,
  description,
}) => {
  return (
    <div className={styles.label_container}>
      <div className={styles.label}>{label}</div>
      <p>{description}</p>
    </div>
  );
};

export default LabelContainer;
